import { motion } from "framer-motion";
import {
  Thermometer,
  Fan,
  ShieldCheck,
  Car,
  WifiHigh,
  Broom,
  User,
  Coffee,
  Storefront,
  Fire,
  Elevator,
  Lightbulb,
} from "@phosphor-icons/react";

const amenities = [
  { icon: Thermometer, title: "Yerden Isıtma", desc: "Tüm dairelerde konforlu yerden ısıtma sistemi" },
  { icon: Fan, title: "Multi Klima", desc: "Her odada bağımsız klima altyapısı" },
  { icon: ShieldCheck, title: "Güvenlik", desc: "7/24 güvenlik ve kamera sistemi" },
  { icon: Car, title: "Otopark", desc: "Geniş ve güvenli otopark alanı" },
  { icon: WifiHigh, title: "Yüksek Hızlı İnternet", desc: "Tüm dairelerde kesintisiz internet" },
  { icon: Broom, title: "Temizlik Hizmeti", desc: "Profesyonel temizlik servisi" },
  { icon: User, title: "Resepsiyon", desc: "Sizi karşılayan özel resepsiyon" },
  { icon: Coffee, title: "Kahvaltı", desc: "Her sabah zengin açık büfe kahvaltı" },
  { icon: Storefront, title: "Kafe", desc: "Tesis bünyesinde rahat kafe alanı" },
  { icon: Fire, title: "Mangal Alanı", desc: "Özel mangal ve sosyal alan" },
  { icon: Elevator, title: "Çift Asansör", desc: "Modern ve güvenli asansör sistemi" },
  { icon: Lightbulb, title: "LED Aydınlatma", desc: "Modern spot LED aydınlatma sistemi" },
];

const Amenities = () => {
  return (
    <section
      id="olanaklar"
      data-testid="amenities-section"
      className="section-padding bg-[#EFEAE2]"
    >
      <div className="container-main">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="overline mb-4 inline-block">Olanaklar</span>
          <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#1A1A1A]">
            Konfor İçin <span className="text-[#4A5D23]">Her Detay</span>
          </h2>
        </motion.div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
          {/* Feature image - spans 2 cols on large */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="sm:col-span-2 lg:row-span-2 img-zoom rounded-2xl overflow-hidden relative group"
          >
            <img
              src="https://images.unsplash.com/photo-1596252890311-caa6a004a6ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxob3RlbCUyMGJyZWFrZmFzdHxlbnwwfHx8fDE3NzYwNDQ2NTV8MA&ixlib=rb-4.1.0&q=85"
              alt="Kahvaltı servisi"
              className="w-full h-full min-h-[300px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <span className="font-['Playfair_Display'] text-2xl font-bold text-white">
                Zengin Kahvaltı & Kafe
              </span>
              <p className="font-['Outfit'] text-sm text-white/80 mt-1">
                Her sabah hazırlanan özel kahvaltı ve gün boyu kafe hizmeti
              </p>
            </div>
          </motion.div>

          {/* Amenity cards */}
          {amenities.map((amenity, i) => (
            <motion.div
              key={amenity.title}
              data-testid={`amenity-card-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: Math.min(i * 0.05, 0.4), duration: 0.5 }}
              className="card-surface p-6 sm:p-8 group transition-all duration-300 hover:-translate-y-1 hover:shadow-lg cursor-default"
            >
              <amenity.icon
                size={36}
                weight="duotone"
                className="text-[#4A5D23] mb-4 transition-transform duration-300 group-hover:scale-110"
              />
              <h3 className="font-['Playfair_Display'] text-lg font-semibold text-[#1A1A1A] mb-2">
                {amenity.title}
              </h3>
              <p className="font-['Outfit'] text-sm text-[#4A4A4A] leading-relaxed">
                {amenity.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Amenities;
